/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiForgotpasswordMutationRequest,
  PostApiForgotpasswordMutationResponse,
} from '../models/PostApiForgotpassword.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiForgotpasswordMutationResponseSchema,
  postApiForgotpasswordMutationRequestSchema,
} from '../zod/postApiForgotpasswordSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiForgotpasswordMutationKey = () =>
  [{ url: '/api/forgotPassword' }] as const;

export type PostApiForgotpasswordMutationKey = ReturnType<
  typeof postApiForgotpasswordMutationKey
>;

/**
 * {@link /api/forgotPassword}
 */
export async function postApiForgotpassword(
  data: PostApiForgotpasswordMutationRequest,
  config: Partial<RequestConfig<PostApiForgotpasswordMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiForgotpasswordMutationRequestSchema.parse(data);
  const res = await request<
    PostApiForgotpasswordMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiForgotpasswordMutationRequest
  >({
    method: 'POST',
    url: `/api/forgotPassword`,
    data: requestData,
    ...requestConfig,
  });
  return postApiForgotpasswordMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/forgotPassword}
 */
export function usePostApiForgotpassword<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiForgotpasswordMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiForgotpasswordMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiForgotpasswordMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiForgotpasswordMutationKey();

  return useMutation<
    PostApiForgotpasswordMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiForgotpasswordMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiForgotpassword(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
